import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { validateDniNie } from "@/lib/dni";

export default function Step2Contact({ data, update, onNext, onBack }) {
  const isEmpresa = data.tipo_servicio === "enseres" && data.tipo_solicitante === "empresa";
  const dniValid = isEmpresa || validateDniNie(data.dni_solicitante || "");
  const canContinue =
    data.nombre_completo?.trim().length > 2 &&
    dniValid &&
    /\S+@\S+\.\S+/.test(data.email || "") &&
    (data.telefono || "").trim().length >= 9 &&
    data.aceptacion_lopd;

  return (
    <div>
      <h2 className="font-heading font-bold text-2xl text-municipal mb-2">Tus datos de contacto</h2>
      <p className="text-gray-500 mb-8">Los usaremos únicamente para confirmar tu solicitud.</p>

      <div className="space-y-5 mb-8">
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <Label className="mb-1.5 block">{isEmpresa ? "Persona de contacto" : "Nombre y apellidos"}</Label>
            <Input
              value={data.nombre_completo || ""}
              onChange={(e) => update({ nombre_completo: e.target.value })}
              placeholder={isEmpresa ? "Nombre y apellidos" : "Nombre y apellidos"}
              data-testid="wizard-nombre-input"
            />
          </div>
          {!isEmpresa && (
            <div>
              <Label className="mb-1.5 block">DNI / NIE del solicitante</Label>
              <Input
                value={data.dni_solicitante || ""}
                onChange={(e) => update({ dni_solicitante: e.target.value.toUpperCase() })}
                placeholder="12345678A"
                data-testid="wizard-dni-input"
              />
              {data.dni_solicitante && !dniValid && (
                <p className="text-xs text-red-500 mt-1">DNI/NIE no válido</p>
              )}
            </div>
          )}
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <Label className="mb-1.5 block">Correo electrónico</Label>
            <Input
              type="email"
              value={data.email || ""}
              onChange={(e) => update({ email: e.target.value })}
              placeholder="correo@ejemplo.com"
              data-testid="wizard-email-input"
            />
          </div>
          <div>
            <Label className="mb-1.5 block">Teléfono</Label>
            <Input
              value={data.telefono || ""}
              onChange={(e) => update({ telefono: e.target.value })}
              placeholder="+34 600 000 000"
              data-testid="wizard-telefono-input"
            />
          </div>
        </div>
        <div className="flex items-start gap-3 pt-2">
          <Checkbox
            id="lopd"
            checked={data.aceptacion_lopd || false}
            onCheckedChange={(v) => update({ aceptacion_lopd: v })}
            data-testid="wizard-lopd-checkbox"
          />
          <Label htmlFor="lopd" className="font-normal text-sm text-gray-600 leading-relaxed cursor-pointer">
            He leído y acepto la política de privacidad. El responsable del tratamiento de mis datos
            es el Ayuntamiento de San Fernando de Henares.
          </Label>
        </div>
      </div>

      <div className="flex justify-between">
        <Button variant="outline" onClick={onBack} className="border-municipal text-municipal">Atrás</Button>
        <Button disabled={!canContinue} onClick={onNext} className="bg-municipal hover:bg-municipal-dark text-white" data-testid="wizard-step2-next">
          Continuar
        </Button>
      </div>
    </div>
  );
}

